<template>
  <main class="rabbit-stamp-page">
    <section class="rabbit-stamp-content" aria-labelledby="rabbit-title">
      <button
        id="rabbit-title"
        type="button"
        class="rabbit-title"
        @click="openRateDialog"
      >
        {{ $t("message.RabbitCardStamp") }}
      </button>
      <v-autocomplete
        v-show="ShowRateList"
        v-model="SelectRate"
        :items="RateList"
        item-text="rateDetail"
        item-value="rateCode"
        :aria-label="$t('message.SelectRate')"
        outlined
        dense
        hide-details
        class="rabbit-rate"
      />
      <form class="rabbit-form" @submit.prevent="SearchParking">
        <v-text-field
          v-model="rabbitCardNo"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          maxlength="13"
          :placeholder="$t('message.RabbitCardNo')"
          :aria-label="$t('message.RabbitCardNo')"
          outlined
          hide-details
          class="rabbit-input"
          @keydown="allowOnlyDigits"
          @input="sanitizeRabbitCardNo"
        />
        <v-btn
          type="submit"
          color="#231F20"
          :disabled="isSubmitting || $terminalSession.state.expired"
          :loading="isSubmitting"
          class="rabbit-search white--text text-capitalize"
          >{{ $t("message.Search") }}</v-btn
        >
      </form>
      <img
        src="@/assets/example_rabbit.png"
        :alt="$t('message.RabbitCardExampleAlt')"
        loading="lazy"
        class="rabbit-example"
      />
    </section>

    <v-dialog
      v-model="RedemptionSuccessDialog"
      persistent
      width="974"
      content-class="rabbit-success-dialog"
    >
      <v-card class="rabbit-success" flat>
        <div class="rabbit-success__timer">
          <v-progress-circular
            color="#c63b00"
            :value="timerProgress"
            size="48"
            width="5"
            ><span>{{ timerCount }}</span></v-progress-circular
          >
        </div>
        <v-card-title class="rabbit-success__title">{{
          $t("message.RedemptionSuccessful")
        }}</v-card-title>
        <v-card-text class="rabbit-success__content">
          <dl class="rabbit-success__details">
            <dt>{{ $t("message.TicketNo") }}</dt>
            <dd>{{ display.ticketNo }}</dd>
            <dt>{{ $t("message.RabbitCardNo") }}</dt>
            <dd>{{ display.rabbitCardNo }}</dd>
            <dt>{{ $t("message.DateTime") }}</dt>
            <dd>{{ dateText }}</dd>
            <dt>{{ $t("message.TimeIn") }}</dt>
            <dd>{{ display.timeIn }}</dd>
            <dt>{{ $t("message.Duration") }}</dt>
            <dd>{{ durationText }}</dd>
            <dt>{{ $t("message.CarLicense") }}</dt>
            <dd>{{ display.plateNo }}</dd>
            <dt>{{ $t("message.VehicleName") }}</dt>
            <dd>{{ display.vehicleName }}</dd>
            <dt>{{ $t("message.RateDetail") }}</dt>
            <dd class="rabbit-success__rate">{{ currentRateDetail }}</dd>
            <dt class="rabbit-success__total">{{ $t("message.Total") }}</dt>
            <dd class="rabbit-success__total">
              {{ numberWithCommas(display.total) }} {{ $t("message.Baht") }}
            </dd>
          </dl>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoginSetRateDialog" persistent width="350">
      <v-card class="rate-login">
        <v-card-title class="rate-login__header"
          ><v-btn
            class="rate-login__close"
            icon
            aria-label="Close"
            @click="closeRateDialog"
            ><v-icon color="white" size="30">mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text class="rate-login__body">
          <v-text-field
            v-model="UsernameRate"
            placeholder="Username"
            autocomplete="username"
            outlined
            hide-details
            @keyup.enter="LoginSetRatePermission"
          />
          <v-text-field
            v-model="PasswordRate"
            placeholder="Password"
            :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="ShowPassword ? 'text' : 'password'"
            autocomplete="current-password"
            outlined
            hide-details
            @click:append="ShowPassword = !ShowPassword"
            @keyup.enter="LoginSetRatePermission"
          />
          <v-btn
            color="#231F20"
            class="white--text"
            block
            @click="LoginSetRatePermission"
            >Log In</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto"
      ><v-card class="pa-6 d-flex flex-column align-center"
        ><v-progress-circular
          indeterminate
          color="#231f20"
          size="64"
          width="6"
        /><span class="mt-4">Loading, please wait...</span></v-card
      ></v-dialog
    >
  </main>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "TerminalStampRabbit",
  data() {
    return {
      url: enurl.apiUrl,
      projectID: localStorage.getItem("ProjectSiteID"),
      LoadingDialog: false,
      isSubmitting: false,
      rabbitCardNo: "",
      RateList: [],
      SelectRate:
        localStorage.getItem("TerminalStampRabbit_SelectRate") || null,
      ShowRateList:
        localStorage.getItem("TerminalStampRabbit_ShowRateList") !== "false",
      RedemptionSuccessDialog: false,
      timerCount: 7,
      timerId: null,
      LoginSetRateDialog: false,
      UsernameRate: "",
      PasswordRate: "",
      ShowPassword: false,
      parking: {},
      display: {
        ticketNo: "",
        rabbitCardNo: "",
        entryDateTime: "",
        timeIn: "",
        parkHH: 0,
        parkMM: 0,
        plateNo: "",
        vehicleName: "",
        rateTH: "",
        rateEN: "",
        total: 0,
      },
    };
  },
  computed: {
    timerProgress() {
      return (this.timerCount / 7) * 100;
    },
    dateText() {
      if (!this.display.entryDateTime) return "";
      const locale = this.$i18n.locale === "th" ? "th-TH" : "en-GB";
      return new Date(this.display.entryDateTime).toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "2-digit",
      }).toUpperCase();
    },
    durationText() {
      return `${this.display.parkHH} ${this.$t("message.Hour")} ${
        this.display.parkMM
      } ${this.$t("message.Minute")}`;
    },
    currentRateDetail() {
      const value =
        this.$t("message.RateDetailLang") === "ENG"
          ? this.display.rateEN
          : this.display.rateTH;
      return (value || "").split("\r\n")[0];
    },
  },
  watch: {
    SelectRate(value) {
      value == null
        ? localStorage.removeItem("TerminalStampRabbit_SelectRate")
        : localStorage.setItem("TerminalStampRabbit_SelectRate", value);
    },
    ShowRateList(value) {
      localStorage.setItem("TerminalStampRabbit_ShowRateList", value);
    },
  },
  mounted() {
    this.GetDataRateCodeTerminalStamp();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    allowOnlyDigits(event) {
      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "Escape",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];
      if (
        controlKeys.includes(event.key) ||
        event.ctrlKey ||
        event.metaKey ||
        /^\d$/.test(event.key)
      ) {
        return;
      }
      event.preventDefault();
    },
    sanitizeRabbitCardNo(value) {
      this.rabbitCardNo = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 13);
    },
    showError(error) {
      if (error?.terminalSessionHandled) return;
      const text =
        error?.response?.data?.message ||
        error?.message ||
        "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";
      return Swal.fire({ icon: "warning", width: 900, text });
    },
    async GetDataRateCodeTerminalStamp() {
      this.LoadingDialog = true;
      try {
        const res = await axios.post(
          `${this.url}Redemption/GetDataRateCodeTerminalStamp`,
          { projectID: this.projectID },
        );
        if (res.data.status !== 0) throw new Error(res.data.message);
        this.RateList = res.data.data || [];
        if (
          !this.RateList.some(
            (x) => String(x.rateCode) === String(this.SelectRate),
          )
        )
          this.SelectRate = null;
      } catch (error) {
        await this.showError(error);
      } finally {
        this.LoadingDialog = false;
      }
    },
    async SearchParking() {
      if (this.$terminalSession.state.expired) return;
      if (this.SelectRate == null) {
        await Swal.fire({
          icon: "warning",
          width: 600,
          text: this.$t("message.SelectRate"),
        });
        return;
      }
      this.isSubmitting = true;
      this.LoadingDialog = true;
      try {
        const res = await axios.post(
          `${this.url}Redemption/getParkingDetailByRabbitID`,
          {
            search:
              this.rabbitCardNo.length === 13
                ? this.rabbitCardNo.slice(1, -1)
                : this.rabbitCardNo,
            LostCard: false,
            projectID: this.projectID,
          },
        );
        if (res.data.status !== 0) throw new Error(res.data.message);
        const data = (res.data.data || [])[0];
        if (!data) throw new Error("ไม่พบข้อมูลบัตร Rabbit");
        if (data.status === "Fail") throw new Error(data.message);
        this.parking = data;
        await this.RedeemData();
      } catch (error) {
        await this.showError(error);
      } finally {
        this.LoadingDialog = false;
        this.isSubmitting = false;
      }
    },
    async RedeemData() {
      const p = this.parking;
      const payload = {
        LogCarparkID: p.logId,
        TerminalID: p.terminalInId,
        DatetimeIn: p.entryDateTime,
        RunningNumber: p.ticketNo,
        PlateNumber: p.plateNo,
        MemberType: p.memberTypeId,
        CarType: p.vehicleTypeId,
        TenantID: parseInt(localStorage.getItem("TenantID"), 10),
        RateCode: this.SelectRate,
        Remark: "",
        projectID: this.projectID,
      };
      const requiredFields = [
        payload.LogCarparkID,
        payload.TerminalID,
        payload.DatetimeIn,
        payload.RunningNumber,
        payload.PlateNumber,
        payload.MemberType,
        payload.CarType,
        payload.TenantID,
        payload.RateCode,
        payload.projectID,
      ];
      if (
        requiredFields.some(
          (v) => v === null || v === undefined || v === "" || Number.isNaN(v),
        )
      )
        throw new Error("กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง !");
      const res = await axios.post(
        `${this.url}Redemption/RedeemParking`,
        payload,
      );
      if (res.data.status !== 0) throw new Error(res.data.message);
      this.bindRedeemResponse(res.data.data);
    },
    bindRedeemResponse(data) {
      if (!data || data.status === "Fail")
        throw new Error(data?.message || "ไม่สามารถ Redeem ได้");
      const parts = String(data.entryDateTime || "").split(" ");
      this.display = {
        ticketNo: data.ticketNo,
        rabbitCardNo: this.rabbitCardNo,
        entryDateTime: data.entryDateTime,
        timeIn: parts.length > 1 ? parts[1] : "",
        parkHH: data.parkHH,
        parkMM: data.parkMM,
        plateNo: data.plateNo,
        vehicleName: data.vehicleTypeName,
        rateTH: data.rateDetailTH || "",
        rateEN: data.rateDetailEN || "",
        total: data.total || 0,
      };
      this.RedemptionSuccessDialog = true;
      this.startTimer();
    },
    startTimer() {
      this.clearTimer();
      this.timerCount = 7;
      this.timerId = setInterval(() => {
        this.timerCount -= 1;
        if (this.timerCount <= 0) {
          this.RedemptionSuccessDialog = false;
          this.rabbitCardNo = "";
          this.clearTimer();
          this.$nextTick(() => {
            const input = this.$el.querySelector(".rabbit-input input");
            if (input) input.focus();
          });
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timerId) clearInterval(this.timerId);
      this.timerId = null;
    },
    numberWithCommas(value) {
      return Number(value || 0).toLocaleString("en-US");
    },
    openRateDialog() {
      this.UsernameRate = "";
      this.PasswordRate = "";
      this.LoginSetRateDialog = true;
    },
    closeRateDialog() {
      this.LoginSetRateDialog = false;
      this.UsernameRate = "";
      this.PasswordRate = "";
    },
    async LoginSetRatePermission() {
      try {
        const res = await axios.post(
          `${this.url}Login/LoginSetRatePermission`,
          { username: this.UsernameRate, password: this.PasswordRate },
        );
        if (res.data.status !== 0) throw new Error(res.data.message);
        this.ShowRateList = !this.ShowRateList;
        this.closeRateDialog();
      } catch (error) {
        await this.showError(error);
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-display: swap;
}
.rabbit-stamp-page {
  min-height: calc(100vh - 158px);
  background: #fff;
  color: #231f20;
}
.rabbit-stamp-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 32px 48px;
}
.rabbit-title {
  padding: 0;
  border: 0;
  background: transparent;
  color: #231f20;
  font: 400 38px/1.2 "Mrs Eaves Lining OT", serif;
  cursor: pointer;
}
.rabbit-title:focus-visible,
.rabbit-search:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 4px;
}
.rabbit-rate {
  width: min(100%, 680px);
  margin-top: 32px;
}
.rabbit-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 1250px);
  margin-top: 54px;
}
.rabbit-input {
  width: 100%;
}
.rabbit-input >>> .v-input__slot {
  min-height: 64px !important;
  padding: 0 30px !important;
  background: #fff !important;
  border-radius: 16px !important;
  box-shadow: 0 6px 8px rgba(35, 31, 32, 0.14);
}
.rabbit-input >>> fieldset {
  border-color: #231f20 !important;
}
.rabbit-input >>> input {
  color: #231f20 !important;
  font: 400 21px/1.5 "Mrs Eaves Lining OT", serif !important;
}
.rabbit-input >>> input::placeholder {
  color: #666;
  opacity: 1;
}
.rabbit-search {
  min-width: 232px !important;
  height: 58px !important;
  margin-top: 36px;
  border-radius: 29px;
  font: 400 18px "Mrs Eaves Lining OT", serif !important;
}
.rabbit-example {
  display: block;
  width: 213px;
  height: 329px;
  margin-top: 28px;
  object-fit: contain;
}
.rabbit-success {
  position: relative;
  padding: 46px 56px 54px;
  border-radius: 12px !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}
.rabbit-success >>> * {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}
.rabbit-success__timer {
  position: absolute;
  top: 36px;
  right: 46px;
}
.rabbit-success__title {
  display: block;
  padding: 6px 72px 42px;
  color: #231f20;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 36px !important;
  font-weight: 400 !important;
  line-height: 1.2 !important;
  letter-spacing: 0.02em !important;
  text-align: center;
}
.rabbit-success__content {
  padding: 0 !important;
}
.rabbit-success__details {
  display: grid;
  grid-template-columns: minmax(150px, 1fr) minmax(220px, 1.2fr);
  gap: 8px 32px;
  margin: 0;
  color: #231f20;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.35;
}
.rabbit-success__details dt,
.rabbit-success__details dd {
  margin: 0;
}
.rabbit-success__details dd {
  text-align: right;
  overflow-wrap: anywhere;
}
.rabbit-success__rate {
  color: #e53922;
}
.rabbit-success__total {
  margin-top: 22px !important;
  font-size: 25px;
}
.rate-login {
  overflow: hidden;
  border-radius: 0 !important;
}
.rate-login__header {
  position: relative;
  height: 62px;
  padding: 0 !important;
  background: #231f20;
}
.rate-login__close {
  position: absolute !important;
  top: 11px;
  right: 10px;
}
.rate-login__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 28px !important;
}
@media (max-width: 600px) {
  .rabbit-stamp-content {
    padding: 42px 16px;
  }
  .rabbit-title {
    font-size: 30px;
  }
  .rabbit-form {
    margin-top: 38px;
  }
  .rabbit-input >>> .v-input__slot {
    min-height: 56px !important;
    padding: 0 18px !important;
  }
  .rabbit-search {
    width: 100%;
    height: 54px !important;
    margin-top: 28px;
  }
  .rabbit-example {
    width: 190px;
    height: 294px;
  }
  .rabbit-success {
    padding: 34px 22px 38px;
  }
  .rabbit-success__timer {
    top: 22px;
    right: 20px;
  }
  .rabbit-success__title {
    padding: 60px 0 30px;
    font-size: 30px;
  }
  .rabbit-success__details {
    grid-template-columns: minmax(120px, 0.9fr) minmax(0, 1.1fr);
    gap: 10px 16px;
    font-size: 18px;
  }
}
</style>
